import { Link } from "react-router-dom";
import { ArrowLeft, Zap } from "lucide-react";

export default function LegalLayout({ title, updated, children, testId }) {
  return (
    <main
      data-testid={testId}
      className="relative min-h-screen bg-[#0a0a0f] text-white font-body"
    >
      <div className="absolute inset-x-0 top-0 h-64 bg-[radial-gradient(ellipse_at_top,rgba(0,212,255,0.18),transparent_60%)] pointer-events-none" />

      <header className="relative border-b border-white/10">
        <div className="mx-auto max-w-4xl px-6 md:px-10 py-6 flex items-center justify-between">
          <Link
            to="/"
            data-testid="legal-back-home"
            className="inline-flex items-center gap-2 text-sm text-zinc-300 hover:text-white transition-colors"
          >
            <ArrowLeft className="h-4 w-4" />
            Back to home
          </Link>
          <Link to="/" className="flex items-center gap-2 group">
            <span className="inline-flex h-7 w-7 items-center justify-center rounded-md border border-[#00d4ff]/40 bg-[#00d4ff]/10">
              <Zap className="h-3.5 w-3.5 text-[#00d4ff]" strokeWidth={2.5} />
            </span>
            <span className="font-display text-base font-bold tracking-tight">
              AI <span className="text-[#00d4ff]">VOLTA</span>
            </span>
          </Link>
        </div>
      </header>

      <section className="relative mx-auto max-w-3xl px-6 md:px-10 pt-14 pb-24">
        <span className="text-xs uppercase tracking-[0.22em] text-[#00d4ff]/90">
          Legal
        </span>
        <h1 className="font-display mt-3 text-4xl sm:text-5xl font-semibold tracking-tight">
          {title}
        </h1>
        <p className="mt-3 text-sm text-zinc-500">Last updated: {updated}</p>

        <article className="legal-prose mt-10 text-zinc-300 text-[15px] leading-relaxed space-y-6">
          {children}
        </article>
      </section>
    </main>
  );
}
